import React, { useState, useEffect, useRef } from 'react';

function Counter({ targetCount }) {
  const [count, setCount] = useState(0); // State to track the count
  const counterRef = useRef(null); // Ref to track the counter element
  const hasAnimated = useRef(false); // Ref to track if animation has already been played

  useEffect(() => {
    const duration = 2000; // Duration of the animation in milliseconds
    const frameRate = 60; // Frame rate (60 frames per second)
    const totalFrames = Math.round((duration / 1000) * frameRate); // Total frames for the animation
    const increment = targetCount / totalFrames; // Amount to increment each frame

    const handleScroll = (entries) => {
      const [entry] = entries; // Get the first entry (our target element)

      // Check if the target element is in the viewport and hasn't been animated yet
      if (entry.isIntersecting && !hasAnimated.current) {
        hasAnimated.current = true; // Mark animation as played
        let currentCount = 0; // Variable to track the current count

        const counterInterval = setInterval(() => {
          currentCount += increment; // Increment the current count
          if (currentCount >= targetCount) { // Check if the count has reached the target
            clearInterval(counterInterval); // Clear the interval when the target is reached
            currentCount = targetCount; // Ensure the count is exactly the target
          }
          setCount(Math.floor(currentCount)); // Update the state with the current count
        }, 1000 / frameRate);
      }
    };

    const observer = new IntersectionObserver(handleScroll, {
      threshold: 0.1, // Trigger when 10% of the element is in view
    });

    const { current } = counterRef; // Destructure the current ref value

    if (current) {
      observer.observe(current); // Start observing the target element
    }

    return () => {
      if (current) {
        observer.unobserve(current); // Cleanup observer on component unmount
      }
    };
  }, [targetCount]); // Depend on targetCount to handle multiple counters

  return (
    <div ref={counterRef}>
      <h1 className="text-white font-bold font-roboto text-2xl">
        {count.toLocaleString()}+
      </h1> {/* Render the count */}
    </div>
  );
}

export default Counter;
